import InstructionsIcon from '@/components/ui/icons/trainers/InstructionsIcon';
import { openLinkInNewTab } from '@/utils/url';
import { useTrainerFeedback } from '@/hooks/useTrainerFeedback';
import TrainerButton from '@/components/ui/trainers/TrainerButton';

export default function Feedback() {
  const { feedback, setFeedback } = useTrainerFeedback();
  return (
    <>
      <div className="fixed left-1/2 top-1/2 z-[10000] flex w-auto max-w-[520px] -translate-x-1/2 -translate-y-1/2 flex-col items-center rounded-lg border border-neutral-700 bg-neutral-800 p-4 text-center text-lg text-neutral-0 shadow-lg">
        <div
          data-was-correct={feedback?.responseWasCorrect}
          className="text-cinnabarDanger-600 data-[was-correct=true]:text-veridianSuccess-600">
          {feedback?.feedbackMessage}
        </div>
        <div className="mt-2 flex flex-row flex-wrap items-center justify-center">
          And remember to regularly consult the
          <InstructionsIcon
            onClick={() => {
              if (feedback?.instructionsLink) {
                openLinkInNewTab(feedback?.instructionsLink);
              }
            }}
          />
          instructions, located in the top right corner of each trainer.
        </div>
        <TrainerButton
          onClick={() => {
            setFeedback(undefined);
          }}
          label={'Ok'}
        />
      </div>
      <div
        className="fixed inset-0 z-50"
        onClick={() => setFeedback(undefined)}
      />
    </>
  );
}
